// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\SmsRefillResponse

import { SmsRefillStatus, SmsRefillType } from './enums.gen';
import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type SmsRefillApiResponse = {
	id: number | null;
	creditAmount: number;
	createdAt: string | null;
	status: SmsRefillStatus;
	type: SmsRefillType;
	hash: string | null;
};

export type SmsRefill = {
	id: number | null;
	creditAmount: number;
	createdAt: DateTime | null;
	status: SmsRefillStatus;
	type: SmsRefillType;
	hash: string | null;
};

export function hydrateSmsRefill(data: SmsRefillApiResponse): SmsRefill {
	return {
		...data,
		createdAt: DateTimefromISO(data.createdAt),
	};
}